import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Routes = [
  // { path: '', redirectTo: 'turf', pathMatch: 'full' },
  // // { path: 'home', loadChildren: './home/home.module#HomeModule' },
  // // { path: 'live', loadChildren: './live/live.module#LiveModule' },
  // // { path: 'matches', loadChildren: './pre-match/pre-match.module#PreMatchModule' },
  // // { path: 'calender', loadChildren: './calender/calender.module#CalenderModule' },
  // // { path: 'results', loadChildren: './results/results.module#ResultsModule' },
  // // { path: 'virtual', loadChildren: './virtual-sport/virtual-sport.module#VirtualSportModule' },
  // // { path: 'registration', loadChildren: './registration/registration.module#RegistrationModule' },
  // // { path: 'promotions', loadChildren: './promotions/promotions.module#PromotionsModule' },
  // // { path: 'rules-page', loadChildren: './footer-page/footer-page.module#FooterPageModule' },
  // { path: 'turf', loadChildren: './turf/turf.module#TurfModule' },
  // { path: '**', redirectTo: 'turf' }
  { path: '', loadChildren: './landing-page/landing-page.module#LandingPageModule' },
  { path: 'home', redirectTo: '' },
  { path: 'miss-ci', loadChildren: './miss-ci/miss-ci.module#MissCiModule' },
  { path: 'how-to', loadChildren: './how-to/how-to.module#HowToModule' },
  { path: 'registration', loadChildren: './registration/registration.module#RegistrationModule' },
  { path: 'fast-signup', loadChildren: './quick-signup/quick-signup.module#QuickSignupModule' },
  { path: 'rules-page', loadChildren: './footer-page/footer-page.module#FooterPageModule' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}
